<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form [formGroup]="formGroup">
        <mat-radio-group aria-label="Select an option" formControlName="publishSections">
            <div fxLayout="column">
                <mat-radio-button [value]="true" class="mb-32">
                    <div fxLayout="column">
                        <span class="font-weight-400 mb-4">{{ 'SECTION.LABEL.IMMEDIATELY' | translate }}</span>
                        <mat-hint class="font-weight-400 text-truncate">{{ immediatelyLabel | translate }}</mat-hint>
                    </div>
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    <div fxLayout="column">
                        <span class="font-weight-400 mb-4">{{ 'SECTION.LABEL.DONT_PUBLISH' | translate }}</span>
                        <mat-hint class="font-weight-400 text-truncate">{{ dontPublishLabel | translate }}</mat-hint>
                    </div>
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()"></app-flat-button>
</div>
